import React from "react";

import OrderSummaryMobile from "./OrderSummaryMobile";
import OrderSummaryWeb from "./OrderSummaryWeb";

const OrderSummary = (props) => (
  <React.Fragment>
    <OrderSummaryWeb {...props} />
    <OrderSummaryMobile {...props} />
  </React.Fragment>
);

export default OrderSummary;
